export default __webpack_public_path__ + "9e842c5a9e0a84d297653cbfb9b44739.svg";